import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { endooSpotManagementAuthModule } from '../Login/endooSpotManagementAuth.module';
import { RouterNetworkComponent } from './RouterNetworkSettings/RouterNetwork.component';
import { RouterSettingsService } from './RouterSettingsService/RouterSettings.service';
import { NewRouterNetworkDialogComponent } from './RouterNetworkDialogs/NewRouterNetworkDialog/newRouterNetwork.dialog.component';
import { DeleteRouterNetworkDialogComponent } from './RouterNetworkDialogs/DeleteRouterNetworkDialog/RouterNetworkDialogs.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { endooSpotComponentsModule } from 'app/Components/endooSpotComponents.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatCardModule,
        MatDividerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatPaginatorModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatExpansionModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        endooSpotManagementAuthModule,
        endooSpotComponentsModule,
    ],
    declarations: [
        RouterNetworkComponent,
        NewRouterNetworkDialogComponent,
        DeleteRouterNetworkDialogComponent,
    ],
    providers: [
        RouterSettingsService,
    ],
    entryComponents: [
        NewRouterNetworkDialogComponent,
        DeleteRouterNetworkDialogComponent,
    ],
    exports: [
        RouterNetworkComponent,
    ],
})
export class endooSpotRouterSettingsModule { }
